import React, { useEffect, useState } from "react"
import "../../pages/RMO/PatientDiagnosis.scss"
import moment from "moment"
import Button from "../Button"
import AddNewVitals from "./AddNewVitals"
import { deleteVital, getAllVitals } from "core/services/api/patientDiagnosisService"
import Toast from "../../components/Toast"

export default function NewVitalsArray({
  isReadOnly,
  patientDetail,
  appointmentDetails,
  recordDetails,
  userDetail,
  heightValue
}: any) {

  const [loading, setLoading] = useState<any>(false)

  const emptyVitalsObj = {
    vitalCaptureDate: "",
    Height: heightValue ? heightValue : "",
    Weight: "",
    BSA: "0",
    BMI: "0",
    Temperature: "",
    BP: "",
    Pulse: "",
    SPO2: "",
    Haemoglobin: "",
    "Total WBC Count": "",
    "Platelets Count": "",
    "Absolute Neutrophil Count (ANC)": "",
    "Total Bilirubin": "",
    "Serum Bilirubin Direct": "",
    "Serum Bilirubin Indirect": "",
    "SGOT (AST)": "",
    "ALT (SGPT)": "",
    "Total Protein": "",
    Albumin: "",
    Globulin: "",
    "AG Ratio": "",
    "Alkaline Phosphatase": "",
    GGT: "",
    "Serum Creatinine": "",
    BUN: "",
    Urea: "",
    "Uric Acid": "",
    Sodium: "",
    Potassium: "",
    Chloride: "",
    "S.Calcium": "",
    LDH: "",
    "eGFR- Creat Clearance": "",
    "HGT-mg/dl": "",
  }

  const emptyBpVitalObj = { "BP Systolic": "", 'BP Diastolic': "" }

  const emptyPayload = {
    VitalsData: {
      vitalCaptureDate: "",
      Height: "",
      Weight: "",
      BSA: "0",
      BMI: "0",
      Temperature: "",
      BP: "",
      Pulse: "",
      SPO2: "",
      Haemoglobin: "",
      "Total WBC Count": "",
      "Platelets Count": "",
      "Absolute Neutrophil Count (ANC)": "",
      "Total Bilirubin": "",
      "Serum Bilirubin Direct": "",
      "Serum Bilirubin Indirect": "",
      "SGOT (AST)": "",
      "ALT (SGPT)": "",
      "Total Protein": "",
      Albumin: "",
      Globulin: "",
      "AG Ratio": "",
      "Alkaline Phosphatase": "",
      GGT: "",
      "Serum Creatinine": "",
      BUN: "",
      Urea: "",
      "Uric Acid": "",
      Sodium: "",
      Potassium: "",
      Chloride: "",
      "S.Calcium": "",
      LDH: "",
      "eGFR- Creat Clearance": "",
      "HGT-mg/dl": "",
    },
    VitalsBp: { "BP Systolic": "", "BP Diastolic": "" },
    errors: { bold: {}, color: {} },
  }

  const [vitalsArray, setVitalsArray] = useState<any>([])
  const [vitalsArrayFirst, setVitalsArrayFirst] = useState<any>([])
  const [bpVitalArray, setBpVitalArray] = useState<any>([])
  const [formVitalErrors, setFormVitalErrors] = useState<any>([])
  const [vitalsPayload, setVitalsPayload] = useState<any>([])
  const [beyondLimit, setBeyondLimit] = useState<any>([])
  const [beyondRange, setBeyondRange] = useState<any>([])
  const [isAllDetails, setAllDetails] = useState<any>([])
  const [isVitalSubmit, setIsVitalSubmit] = useState<any>([])
  const [isMandatoryFields, setMandatoryFields] = useState<any>([])
  const [isVitalData, setIsVitalData] = useState<any>([])
  const [isDataChanged, setIsDataChanged] = useState<any>([])
  const [isSavedAlready, setIsSavedAlready] = useState<any>([])
  const [displayToast, toggleDisplayToast] = useState<any>(false)

  const validateVitals = (values: any, bpValue: any, index: any) => {
    const bold: any = {}
    const color: any = {}

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/
    const isIPD = appointmentDetails?.appointmentType === "IPD"
    // drpodown validation
    if (
      (values.Pulse !== "" && values.Pulse !== null) &&
      ((values.Pulse >= 100 && values.Pulse <= 120) ||
        (values.Pulse >= 40 && values.Pulse <= 60))
    ) {
      bold.Pulse = true
    } else if (
      ((values.Pulse !== "" && values.Pulse !== null) &&
        (values.Pulse >= 120 || values.Pulse <= 40) || values.Pulse.toLowerCase() === "na")
    ) {
      color.Pulse = true
    }
    if (
      (values.Height !== "" && values?.Height !== null) &&
      ((values.Height >= 205 && values.Height < 210) || values.Height <= 139)
    ) {
      bold.Height = true
    } else if ((values.Height !== "" && values?.Height !== null) && (values.Height >= 210 || values.Height.toLowerCase() === "na")) {
      color.Height = true
    }
    if (
      (values.Weight !== "" && values?.Weight !== null) &&
      values.Weight >= 130 &&
      values.Weight < 200
    ) {
      bold.Weight = true
    } else if ((values.Weight !== "" && values?.Weight !== null) && (values.Weight >= 200 || values?.Weight.toLowerCase() === "na")) {
      color.Weight = true
    }
    if (
      (values.Temperature !== "" && values?.Temperature !== null) &&
      values.Temperature >= 99 &&
      values.Temperature < 110
    ) {
      bold.Temperature = true
    } else if ((values.Temperature !== "" && values?.Temperature !== null) && (values.Temperature >= 110 || values?.Temperature.toLowerCase() === "na")) {
      color.Temperature = true
    }
    if (Object.keys(bpValue[index]).length > 0) {
      if (bpValue?.[index]?.["BP Systolic"]) {
        if (Number(bpValue[index]?.["BP Systolic"]) > 140 && Number(bpValue[index]?.["BP Systolic"]) < 200) {
          bold["BP Systolic"] = true
        } else if ((Number(bpValue?.[index]?.["BP Systolic"]) < 90 || Number(bpValue[index]?.["BP Systolic"]) >= 200) || bpValue[index]?.["BP Systolic"].toLowerCase() === "na") {
          color["BP Systolic"] = true
        }
      }
      if (bpValue?.[index]?.["BP Diastolic"]) {
        if (Number(bpValue[index]?.["BP Diastolic"]) > 50 && Number(bpValue[index]?.["BP Diastolic"]) < 60) {
          bold["BP Diastolic"] = true
        } else if ((Number(bpValue[index]?.["BP Diastolic"]) <= 50 || Number(bpValue[index]?.["BP Diastolic"]) >= 90) || bpValue[index]?.["BP Diastolic"].toLowerCase() === "na") {
          color["BP Diastolic"] = true
        }
      }
    }
    if ((values.SPO2 !== "" && values.SPO2 !== null) && values.SPO2 >= 90 && values.SPO2 < 92) {
      bold.SPO2 = true
    } else if ((values.SPO2 !== "" && values.SPO2 !== null) && ((values.SPO2 > 100 || values.SPO2 < 90) || values.SPO2.toLowerCase() === "na")) {
      color.SPO2 = true
    }
    if (patientDetail?.gender === "Male") {
      if (
        (values.Haemoglobin !== "" && values.Haemoglobin !== null) &&
        values.Haemoglobin >= 8 &&
        values.Haemoglobin <= 14
      ) {
        bold.Haemoglobin = true
      } else if (
        (values.Haemoglobin !== "" && values.Haemoglobin !== null) &&
        ((values.Haemoglobin > 18 || values.Haemoglobin < 8) || values.Haemoglobin.toLowerCase() === "na")
      ) {
        color.Haemoglobin = true
      }
    } else if (patientDetail?.gender === "Female") {
      if (
        (values.Haemoglobin !== "" && values.Haemoglobin !== null) &&
        ((values.Haemoglobin >= 8 && values.Haemoglobin <= 12.5) ||
          (values.Haemoglobin >= 16.5 && values.Haemoglobin <= 18))
      ) {
        bold.Haemoglobin = true
      } else if (
        (values.Haemoglobin !== "" && values.Haemoglobin !== null) &&
        ((values.Haemoglobin > 18 || values.Haemoglobin < 8) || values.Haemoglobin.toLowerCase() === "na")
      ) {
        color.Haemoglobin = true
      }
    }
    if (
      (values["Total WBC Count"] !== "" && values["Total WBC Count"] !== null) &&
      ((values["Total WBC Count"] > 3000 && values["Total WBC Count"] < 4000) ||
        (values["Total WBC Count"] > 10000 &&
          values["Total WBC Count"] < 20000))
    ) {
      bold["Total WBC Count"] = true
    } else if (
      (values["Total WBC Count"] !== "" && values["Total WBC Count"] !== null) &&
      ((values["Total WBC Count"] < 3000 || values["Total WBC Count"] > 20000) || values["Total WBC Count"].toLowerCase() === "na")
    ) {
      color["Total WBC Count"] = true
    }
    if (
      (values["Absolute Neutrophil Count (ANC)"] !== "" && values["Absolute Neutrophil Count (ANC)"] !== null) &&
      ((values["Absolute Neutrophil Count (ANC)"] < 1500 ||
        values["Absolute Neutrophil Count (ANC)"] > 6000) || values["Absolute Neutrophil Count (ANC)"].toLowerCase() === "na")
    ) {
      color["Absolute Neutrophil Count (ANC)"] = true
    }
    if (
      (values["Platelets Count"] !== "" && values["Platelets Count"] !== null) &&
      ((values["Platelets Count"] > 100 && values["Platelets Count"] < 150) ||
        (values["Platelets Count"] > 400 && values["Platelets Count"] < 600))
    ) {
      bold["Platelets Count"] = true
    } else if (
      (values["Platelets Count"] !== "" && values["Platelets Count"] !== null) &&
      ((values["Platelets Count"] < 100 || values["Platelets Count"] > 600) || values["Platelets Count"].toLowerCase() === "na")
    ) {
      color["Platelets Count"] = true
    }
    if (
      (values["Serum Creatinine"] !== "" && values["Serum Creatinine"] !== null) &&
      values["Serum Creatinine"] > 1.1 &&
      values["Serum Creatinine"] < 2
    ) {
      bold["Serum Creatinine"] = true
    } else if (
      (values["Serum Creatinine"] !== "" && values["Serum Creatinine"] !== null) &&
      ((values["Serum Creatinine"] > 2 || values["Serum Creatinine"] < 0.6) || values["Serum Creatinine"].toLowerCase() === "na")
    ) {
      color["Serum Creatinine"] = true
    }
    if (
      (values["eGFR- Creat Clearance"] !== "" && values["eGFR- Creat Clearance"] !== null) &&
      ((values["eGFR- Creat Clearance"] > 30 &&
        values["eGFR- Creat Clearance"] < 60) ||
        (values["eGFR- Creat Clearance"] > 130 &&
          values["eGFR- Creat Clearance"] < 400))
    ) {
      bold["eGFR- Creat Clearance"] = true
    } else if (
      (values["eGFR- Creat Clearance"] !== "" && values["eGFR- Creat Clearance"] !== null) &&
      ((values["eGFR- Creat Clearance"] < 30 ||
        values["eGFR- Creat Clearance"] > 400) || values["eGFR- Creat Clearance"].toLowerCase() === "na")
    ) {
      color["eGFR- Creat Clearance"] = true
    }
    if (
      (values["Total Bilirubin"] !== "" && values["Total Bilirubin"] !== null) &&
      values["Total Bilirubin"] > 1.2 &&
      values["Total Bilirubin"] < 10
    ) {
      bold["Total Bilirubin"] = true
    } else if (
      (values["Total Bilirubin"] !== "" && values["Total Bilirubin"] !== null) &&
      (values["Total Bilirubin"] > 10 || values["Total Bilirubin"].toLowerCase() === "na")
    ) {
      color["Total Bilirubin"] = true
    }
    if (
      (values["Serum Bilirubin Direct"] !== "" && values["Serum Bilirubin Direct"] !== null) &&
      values["Serum Bilirubin Direct"] > 0.4 &&
      values["Serum Bilirubin Direct"] < 0.1
    ) {
      bold["Serum Bilirubin Direct"] = true
    } else if (values["Serum Bilirubin Direct"].toLowerCase() === "na") {
      color["Serum Bilirubin Direct"] = true
    }
    if (values["Serum Bilirubin Indirect"].toLowerCase() === "na") {
      color["Serum Bilirubin Indirect"] = true
    }
    if (
      (values["ALT (SGPT)"] !== "" && values["ALT (SGPT)"] !== null) &&
      values["ALT (SGPT)"] > 44 &&
      values["ALT (SGPT)"] < 180
    ) {
      bold["ALT (SGPT)"] = true
    } else if ((values["ALT (SGPT)"] !== "" && values["ALT (SGPT)"] !== null) && (values["ALT (SGPT)"] > 180 || values["ALT (SGPT)"].toLowerCase() === "na")) {
      color["ALT (SGPT)"] = true
    }
    if (
      (values["SGOT (AST)"] !== "" && values["SGOT (AST)"] !== null) &&
      ((values["SGOT (AST)"] > 38 && values["SGOT (AST)"] < 150) ||
        values["SGOT (AST)"] < 8)
    ) {
      bold["SGOT (AST)"] = true
    } else if ((values["SGOT (AST)"] !== "" && values["SGOT (AST)"] !== null) && (values["SGOT (AST)"] > 150 || values["SGOT (AST)"].toLowerCase() === "na")) {
      color["SGOT (AST)"] = true
    }
    if (
      ((values["Total Protein"] !== "" && values["Total Protein"] !== null) &&
        values["Total Protein"] > 5 &&
        values["Total Protein"] < 6.7) ||
      values["Total Protein"] > 8.3
    ) {
      bold["Total Protein"] = true
    } else if ((values["Total Protein"] !== "" && values["Total Protein"] !== null) && (values["Total Protein"] < 5 || values["Total Protein"].toLowerCase() === "na")) {
      color["Total Protein"] = true
    }
    if (
      ((values["Albumin"] !== "" && values["Albumin"] !== null) &&
        values["Albumin"] > 2 &&
        values["Albumin"] < 3.8) ||
      values["Albumin"] > 5
    ) {
      bold["Albumin"] = true
    } else if ((values["Albumin"] !== "" && values["Albumin"] !== null) && (values["Albumin"] < 2 || values["Albumin"].toLowerCase() === "na")) {
      color["Albumin"] = true
    }
    if (
      (values["S.Calcium"] !== "" && values["S.Calcium"] !== null) &&
      ((values["S.Calcium"] > 7 && values["S.Calcium"] < 8.4) ||
        (values["S.Calcium"] > 10.2 && values["S.Calcium"] < 14))
    ) {
      bold["S.Calcium"] = true
    } else if (
      (values["S.Calcium"] !== "" && values["S.Calcium"] !== null) &&
      ((values["S.Calcium"] < 7 || values["S.Calcium"] > 14) || values["S.Calcium"].toLowerCase() === "na")
    ) {
      color["S.Calcium"] = true
    }
    if (
      (values["HGT-mg/dl"] !== "" && values["HGT-mg/dl"] !== null) &&
      ((values["HGT-mg/dl"] > 40 && values["HGT-mg/dl"] < 80) ||
        (values["HGT-mg/dl"] > 140 && values["HGT-mg/dl"] < 300))
    ) {
      bold["HGT-mg/dl"] = true
    } else if (
      (values["HGT-mg/dl"] !== "" && values["HGT-mg/dl"] !== null) &&
      ((values["HGT-mg/dl"] < 40 || values["HGT-mg/dl"] > 300) || values["HGT-mg/dl"].toLowerCase() === "na")
    ) {
      color["HGT-mg/dl"] = true
    }
    if (
      (values.Globulin !== "" && values.Globulin !== null) &&
      (values.Globulin < 2.9 || values.Globulin > 3.3)
    ) {
      bold.Globulin = true
    } else if (values.Globulin.toLowerCase() === "na") {
      color.Globulin = true
    }
    if (
      (values["AG Ratio"] !== "" && values["AG Ratio"] !== null) &&
      (values["AG Ratio"] < 1.3 || values["AG Ratio"] > 2.5)
    ) {
      bold["AG Ratio"] = true
    } else if (values["AG Ratio"].toLowerCase() === "na") {
      color["AG Ratio"] = true
    }
    if (
      (values["Alkaline Phosphatase"] !== "" && values["Alkaline Phosphatase"] !== null) &&
      (values["Alkaline Phosphatase"] < 33 ||
        values["Alkaline Phosphatase"] > 111)
    ) {
      bold["Alkaline Phosphatase"] = true
    } else if (values["Alkaline Phosphatase"].toLowerCase() === "na") {
      color["Alkaline Phosphatase"] = true
    }
    if ((values.GGT !== "" && values.GGT !== null) && (values.GGT < 16 || values.GGT > 73)) {
      bold.GGT = true
    } else if (values.GGT.toLowerCase() === "na") {
      color.GGT = true
    }
    if ((values.BUN !== "" && values.BUN !== null) && (values.BUN < 8 || values.BUN > 23)) {
      bold.BUN = true
    } else if (values.BUN.toLowerCase() === "na") {
      color.BUN = true
    }
    if ((values.Urea !== "" && values.Urea !== null) && (values.Urea < 15 || values.Urea > 40)) {
      bold.Urea = true
    } else if (values.Urea.toLowerCase() === "na") {
      color.Urea = true
    }
    if (
      (values["Uric Acid"] !== "" && values["Uric Acid"] !== null) &&
      (values["Uric Acid"] < 3 || values["Uric Acid"] > 5.5)
    ) {
      bold["Uric Acid"] = true
    } else if (values["Uric Acid"].toLowerCase() === "na") {
      color["Uric Acid"] = true
    }
    if ((values.Sodium !== "" && values.Sodium !== null) && (values.Sodium < 136 || values.Sodium > 149)) {
      bold.Sodium = true
    } else if (values.Sodium.toLowerCase() === "na") {
      color.Sodium = true
    }
    if (
      (values.Potassium !== "" && values.Potassium !== null) &&
      (values.Potassium < 3.8 || values.Potassium > 5)
    ) {
      bold.Potassium = true
    } else if (values.Potassium.toLowerCase() === "na") {
      color.Potassium = true
    }
    if ((values.Chloride !== "" && values.Chloride !== null) && (values.Chloride < 96 || values.Chloride > 108)) {
      bold.Chloride = true
    } else if (values.Chloride.toLowerCase() === "na") {
      color.Chloride = true
    }
    if ((values.LDH !== "" && values.LDH !== null) && (values.LDH < 106 || values.LDH > 211)) {
      bold.LDH = true
    } else if (values.LDH.toLowerCase() === "na") {
      color.LDH = true
    }
    const vitalsMetaData: any = { bold, color }
    return vitalsMetaData
  }

  const updateVitalsArray = (data: any, isFirst: any = false) => {
    let vital: any = [...vitalsArray]
    let bpVital: any = [...bpVitalArray]
    data.map((item: any, index: any) => {
      const { vitalCaptureDate, height, weight, bsa, bmi, temperature, pulseInfo, spo2, hemoglobin, wbcCount, plateletsCount, anc, serumCreatinine, egfr, totalBilirubinDirect, sgot, sgpt, salbumin, totalProtein, scalcium, hgt, serumBilirubinDirect, serumBilirubinInDirect, globulin, agRatio, alkalinePhosphate, ggt, bun, urea, uricAcid, sodium, potassium, chloride, ldh } = item
      const temp = {
        vitalCaptureDate: vitalCaptureDate,
        previousVitalCaptureDate: vitalCaptureDate,
        Height: height,
        Weight: weight,
        BSA: bsa,
        BMI: bmi,
        Temperature: temperature,
        Pulse: pulseInfo,
        SPO2: spo2,
        Haemoglobin: hemoglobin,
        "Total WBC Count": wbcCount,
        "Platelets Count": plateletsCount,
        "Absolute Neutrophil Count (ANC)": anc,
        "Serum Creatinine": serumCreatinine,
        "eGFR- Creat Clearance": egfr,
        "Total Bilirubin": totalBilirubinDirect,
        "SGOT (AST)": sgot,
        "ALT (SGPT)": sgpt,
        Albumin: salbumin,
        "Total Protein": totalProtein,
        "S.Calcium": scalcium,
        "HGT-mg/dl": hgt,
        "Serum Bilirubin Direct": serumBilirubinDirect,
        "Serum Bilirubin Indirect": serumBilirubinInDirect,
        Globulin: globulin,
        "AG Ratio": agRatio,
        "Alkaline Phosphatase": alkalinePhosphate,
        GGT: ggt,
        BUN: bun,
        Urea: urea,
        "Uric Acid": uricAcid,
        Sodium: sodium,
        Potassium: potassium,
        Chloride: chloride,
        LDH: ldh,
      }
      vital[index] = temp

      const bpTemp = { 'BP Systolic': item?.bpSystolic, 'BP Diastolic': item?.bpDiastolic }
      bpVital[index] = bpTemp
    })

    setVitalsArray(vital)
    setBpVitalArray(bpVital)


    let result
    let formErrorVital: any = [...formVitalErrors]
    vital?.map((vitalSingle: any, i: any) => {
      result = validateVitals(vitalSingle, bpVital, i)
      formErrorVital[i] = result
    })
    setFormVitalErrors(formErrorVital)

    let tempVitalsPayload: any = [...vitalsPayload]
    vital?.map((vitalSingle1: any, i: any) => {
      const tempData = {
        VitalsData: vitalSingle1,
        VitalsBp: bpVital[i],
        errors: formErrorVital[i],
      }
      tempVitalsPayload[i] = tempData
    })
    setVitalsPayload(tempVitalsPayload)

    if (isFirst) {
      setVitalsArrayFirst(vital)
    }
  }

  const updateFormErrors = (data: any, bpVital: any) => {
    let result
    let formErrorVital: any = [...formVitalErrors]
    data?.map((vitalSingle: any, i: any) => {
      result = validateVitals(vitalSingle, bpVital, i)
      formErrorVital[i] = result
    })
    setFormVitalErrors(formErrorVital)
  }

  useEffect(() => {
    const temp = Array(vitalsArray?.length).fill(false);
    const temp1 = Array(vitalsArray?.length).fill(true);

    setBeyondLimit(temp)
    setBeyondRange(temp)
    setAllDetails(temp)
    setIsVitalSubmit(temp)
    setMandatoryFields(temp)
    setIsVitalData(temp)
    setIsDataChanged(temp)
    setIsSavedAlready(temp1)
  }, [vitalsArrayFirst])

  const getAllVitalsData = (id: any, isFirstVital: any = false) => {
    getAllVitals(id)
      .then((data: any) => {
        updateVitalsArray(data.data, isFirstVital)
      })
      .catch((err: any) => {
        console.log(err)
      })
  }

  useEffect(() => {
    getAllVitalsData(recordDetails?.id, true)
  }, [appointmentDetails?.id, recordDetails?.id])

  const onAddNewClick = () => {
    if (isSavedAlready?.includes(false) && !isDataChanged?.includes(true)) {
      toggleDisplayToast({
        text: 'New vitals block is already added,Please save the datails',
        type: "warning",
      });
      return;
    }
    const ChangeArray = isDataChanged?.map((value: any, index: any) => (value ? index : null))?.filter((value: any) => value !== null);

    if (ChangeArray?.length === 0) {
      updateFormErrors([...vitalsArray, emptyVitalsObj], [...bpVitalArray, emptyBpVitalObj])
      setVitalsArray([...vitalsArray, emptyVitalsObj])
      setBpVitalArray([...bpVitalArray, emptyBpVitalObj])
      setVitalsPayload([...vitalsPayload, emptyPayload])
      setBeyondLimit([...beyondLimit, false])
      setBeyondRange([...beyondRange, false])
      setAllDetails([...isAllDetails, false])
      setIsVitalSubmit([...isVitalSubmit, false])
      setMandatoryFields([...isMandatoryFields, false])
      setIsVitalData([...isVitalData, false])
      setIsDataChanged([...isDataChanged, false])
      setIsSavedAlready([...isSavedAlready, false])
    } else if (ChangeArray?.length > 0) {
      toggleDisplayToast({
        text: `Please save vitals for date: ${ChangeArray.map((i: any) => moment(vitalsArray[i]?.vitalCaptureDate)?.format("DD-MM-YYYY")).join(", ")}  to continue adding vitals for additional dates`,
        type: "error",
      });
    }
  }

  const vitalsSplice = (vitalInd: any) => {
    const viData = [...vitalsArray]
    viData.splice(vitalInd, 1)
    setVitalsArray(viData)

    const bpViData = [...bpVitalArray]
    bpViData.splice(vitalInd, 1)
    setBpVitalArray(bpViData)

    const formErrorList = [...formVitalErrors]
    formErrorList.splice(vitalInd, 1)
    setFormVitalErrors(formErrorList)

    const tempPay = [...vitalsPayload]
    tempPay.splice(vitalInd, 1)
    setVitalsPayload(tempPay)

    const tempLimit = [...beyondLimit]
    tempLimit.splice(vitalInd, 1)
    setBeyondLimit(tempLimit)

    const tempRange = [...beyondRange]
    tempRange.splice(vitalInd, 1)
    setBeyondRange(tempRange)

    const tempDetails = [...isAllDetails]
    tempDetails.splice(vitalInd, 1)
    setAllDetails(tempDetails)

    const tempIsSave = [...isVitalSubmit]
    tempIsSave.splice(vitalInd, 1)
    setIsVitalSubmit(tempIsSave)

    const tempMandatory = [...isMandatoryFields]
    tempMandatory.splice(vitalInd, 1)
    setMandatoryFields(tempMandatory)

    const tempData = [...isVitalData]
    tempData.splice(vitalInd, 1)
    setIsVitalData(tempData)

    const tempChange = [...isDataChanged]
    tempChange.splice(vitalInd, 1)
    setIsDataChanged(tempChange)

    const tempSavedAlready = [...isSavedAlready]
    tempSavedAlready.splice(vitalInd, 1)
    setIsSavedAlready(tempSavedAlready)

  }

  const deleteVitalBlock = (vitalInd: any, date: any) => {
    if (date) {
      deleteVital(date, recordDetails?.id)
        .then((data: any) => {
          vitalsSplice(vitalInd)
          toggleDisplayToast({
            text: 'Vitals data deleted successfully',
            type: "success",
          });
        })
        .catch((err: any) => console.error(err))
    } else {
      vitalsSplice(vitalInd)
      toggleDisplayToast({
        text: 'Vitals data deleted successfully',
        type: "success",
      });
    }
  }

  const handleClearClick = (vitalInd: any) => {
    if (!isSavedAlready[vitalInd]) {

      const tempVital = [...vitalsArray]
      tempVital[vitalInd] = emptyVitalsObj
      setVitalsArray(tempVital)

      const tempBpVital = [...bpVitalArray]
      tempBpVital[vitalInd] = emptyBpVitalObj
      setBpVitalArray(tempBpVital)

      updateFormErrors(tempVital, tempBpVital)

      const tempPayload = [...vitalsPayload]
      tempPayload[vitalInd] = emptyPayload
      setVitalsPayload(tempPayload)

      const tempLimit = [...beyondLimit]
      tempLimit[vitalInd] = false
      setBeyondLimit(tempLimit)

      const tempData = [...isVitalData]
      tempData[vitalInd] = false
      setIsVitalData(tempData)

      const tempDetails = [...isAllDetails]
      tempDetails[vitalInd] = false
      setAllDetails(tempDetails)

      const tempSubmit1 = [...isVitalSubmit]
      tempSubmit1[vitalInd] = false
      setIsVitalSubmit(tempSubmit1)

      const tempChange = [...isDataChanged]
      tempChange[vitalInd] = false
      setIsDataChanged(tempChange)

      const tempSavedAlready = [...isSavedAlready]
      tempSavedAlready[vitalInd] = false
      setIsSavedAlready(tempSavedAlready)

      const tempRange = [...beyondRange]
      tempRange[vitalInd] = false
      setBeyondRange(tempRange)

      const tempFields = [...isMandatoryFields]
      tempFields[vitalInd] = false
      setMandatoryFields(tempFields)

    }
  }


  return (
    <>
      {
        loading ? (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        ) : null
      }
      {displayToast ? (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => toggleDisplayToast(false)}
          onCloseText="Close"
          onClickText={null}
        />
      ) : null}
      <div className="visit-container">
        {isReadOnly ? (
          vitalsArray && vitalsArray?.length > 0 && (
            <div className="vital-header-extra">Extra Vitals</div>
          )
        ) : (
          <div className="vital-header-extra">Extra Vitals</div>
        )}
        {vitalsArray && vitalsArray?.map((viSingle: any, index: any) => {
          return (
            <>
              <div className="horizontal-line"></div>
              <AddNewVitals
                getAllVitalsData={getAllVitalsData}
                singleData={viSingle}
                vitalsArray={vitalsArray}
                setVitalsArray={setVitalsArray}
                setMandatoryFields={setMandatoryFields}
                isMandatoryFields={isMandatoryFields}
                appointmentDetails={appointmentDetails}
                recordDetails={recordDetails}
                patientDetail={patientDetail}
                singleBpData={bpVitalArray[index]}
                vitalIndex={index}
                setBpVitalArray={setBpVitalArray}
                bpVitalArray={bpVitalArray}
                formVitalErrors={formVitalErrors}
                setFormVitalErrors={setFormVitalErrors}
                isReadOnly={isReadOnly}
                deleteVitalBlock={deleteVitalBlock}
                validateVitals={validateVitals}
                setLoading={setLoading}
                setVitalsPayload={setVitalsPayload}
                vitalsPayload={vitalsPayload}
                setBeyondLimit={setBeyondLimit}
                setBeyondRange={setBeyondRange}
                beyondLimit={beyondLimit}
                beyondRange={beyondRange}
                isAllDetails={isAllDetails}
                setAllDetails={setAllDetails}
                isVitalSubmit={isVitalSubmit}
                setIsVitalSubmit={setIsVitalSubmit}
                setIsVitalData={setIsVitalData}
                isVitalData={isVitalData}
                isDataChanged={isDataChanged}
                setIsDataChanged={setIsDataChanged}
                setIsSavedAlready={setIsSavedAlready}
                isSavedAlready={isSavedAlready}
                userDetail={userDetail}
                emptyVitalsObj={emptyVitalsObj}
                handleClearClick={handleClearClick}
              />
            </>
          )
        })}
        {isReadOnly ? "" :
          <Button disabled={isReadOnly} type={"button"} text="Add New" id="add-vitals" onClick={onAddNewClick}></Button>}
      </div>
    </>
  )

}

